export default function KeywordsIcon() {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2.42188" y="6" width="10.0312" height="3" rx="1.5" fill="#F655DD" stroke="#2B2F38" />
      <rect x="2.42188" y="16" width="10.0312" height="3" rx="1.5" fill="#F655DD" stroke="#2B2F38" />
      <rect x="14.4375" y="16" width="6.125" height="3" rx="1.5" fill="#9A5BFF" stroke="#2B2F38" />
      <rect x="10.6719" y="11" width="8.28125" height="3" rx="1.5" fill="#F655DD" stroke="#2B2F38" />
      <rect x="14.4531" y="6" width="7.125" height="3" rx="1.5" fill="#CA35FF" stroke="#2B2F38" />
      <rect x="2.42188" y="11" width="6.28125" height="3" rx="1.5" fill="#CA35FF" stroke="#2B2F38" />
    </svg>
  )
}
